import {BaseEntity as BaseEntityTypeORM, PrimaryGeneratedColumn} from "typeorm";
import {Min} from "class-validator";

export class BaseEntity extends BaseEntityTypeORM {
  @PrimaryGeneratedColumn({type: 'integer'})
  @Min(1)
  id: number;

  public equals(model: { id: number | undefined } | null | undefined): boolean {
    return model !== null && model !== undefined && this.id === model.id;
  };

  public async load(relations: (keyof this)[] | keyof this): Promise<void> {
    if (!Array.isArray(relations)) {
      relations = [relations];
    }

    const mapped = {};

    // @ts-ignore
    relations.forEach(relation => mapped[relation] = true);

    // @ts-ignore
    const loaded = await this.constructor.findOneOrFail({
      where: {id: this.id},
      relations: mapped
    });

    relations.forEach(relation => this[relation] = loaded[relation]);
  }
}
